<template>
  <!-- 这个是项目管理 -->
  <div class="projectManagement">
    <div class="title_box">
      <h4>项目管理</h4>
    </div>
    <!-- 卡片 -->
    <el-card class="box-card">
      <!-- 搜索区域 -->
      <div class="searchBox">
        <!-- 左边的输入框 -->
        <div class="inputBox">
          <el-input
            :clearable="true"
            placeholder="请输入项目名称"
            v-model="ProjectsName"
            @change="changeX"
          >
          </el-input>
          <el-input
            :clearable="true"
            placeholder="请输入专家名称"
            v-model="ExpertsName"
            @change="changeZ"
          >
          </el-input>
          <span class="setDateTitle">创建时间</span>
          <el-date-picker
            v-model="Stage"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </div>
        <!-- 右侧的按钮 -->
        <div class="buttonBox">
          <el-button
            size="medium"
            style="background: #484c7f; color: #fff"
            @click="search"
          >搜索</el-button>
          <el-button
            size="medium"
            style="background: #6c757d; color: #fff"
            @click="addHandle"
          >添加项目</el-button>
        </div>
      </div>
      <!-- 搜索区域结束 -->
      <!-- 列表区域 -->
      <div class="table_box">
        <el-table
          :data="ProjectsObj.list"
          style="width: 100%"
        >
          <!--增加内容-->
          <template slot="empty">
            <p>{{tableText}}</p>
          </template>

          <el-table-column
            label="项目名称"
            min-width="20%"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.name"
                placement="top-start"
              >
                <span> {{ scope.row.name }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="牵头专家"
            min-width="20%"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.expert.length==0">
                <el-tooltip
                  class="item"
                  effect="light"
                  placement="top-start"
                  content="暂未选择"
                >
                  <span>暂未选择</span>
                </el-tooltip>
              </div>
              <div v-if="scope.row.expert.length!=0">
                <el-tooltip
                  class="item"
                  effect="light"
                  placement="top-start"
                  :content="scope.row.expert.map(item =>item.name).join('，')"
                >
                  <div>
                    <span
                      v-for="(item,index) in scope.row.expert"
                      :key="index"
                    >
                      <span v-if="scope.row.expert.length!=0 && index < 3 ">
                        <span>{{item.name}}</span>
                        <span
                          v-if="index !== (scope.row.expert.length<=2?scope.row.expert.length-1:2)"
                        >，</span>
                      </span>
                      <span v-if="scope.row.expert.length==0">暂未选择</span>
                    </span>
                  </div>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="申办方"
            min-width="20%"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.sponsor"
                placement="top-start"
              >
                <span> {{ scope.row.sponsor }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            min-width="20%"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.create_time"
                placement="top-start"
              >
                <span>{{ scope.row.create_time }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="项目信息查看"
            min-width="20%"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                type="primary"
                @click="ProjectHome(scope.row)"
              >查看项目</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="200px"
          >
            <template slot-scope="scope">
              <!-- 这里是三个图标 -->
              <span
                class="iconstyle lookat iconfont icon-chakan"
                @click="examine(scope.row)"
              ></span>
              <span
                class="iconstyle edtor iconfont icon-bianji icon-size"
                @click="handleEdit(scope.row)"
              ></span>
              <span
                class="iconstyle delete iconfont icon-shanchu icon-size"
                @click="handleDelete(scope.row)"
              ></span>
              <el-popover
                placement="bottom"
                width="410"
                trigger="click"
                :offset="-180"
              >
                <div class="share-box">
                  <div>
                    <h4>邀请</h4>
                  </div>
                  <div class="share-box-item">
                    <el-select
                      style="width:280px;"
                      v-model="value"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                    <div
                      class="share-box-btn"
                      :class="shareIshow?'share-active':''"
                      @click="shareClick(scope.row)"
                      v-throttle="2000"
                    >{{shareIshow?'复制成功':'复制链接'}}</div>
                  </div>

                </div>

                <span
                  slot="reference"
                  class="iconstyle"
                >
                  <img src="../../assets/image/fenxiang.png">
                </span>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 列表区域结束 -->
    </el-card>
    <!-- 这里边是一个分页 -->
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :page-count="ProjectsObj.pages"
        :current-page.sync="currentPage"
      >
      </el-pagination>
    </div>
    <!-- 气泡对话框 -->
    <!-- :before-close="handleClose" -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="515px"
    >
      <div class="popup">
        <span>确认删除本项目信息吗？</span>
        <div class="buttons">
          <el-button @click="cansol">取消</el-button>
          <el-button>确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      tableText: '正在加载...',
      // 是否弹出对话框
      dialogVisible: false,
      //?
      afterLeadExpertList: [],
      LeadExpertList: [],
      ProjectsObj: {},
      ProjectsList: [],
      ProjectsName: '',//项目名称
      ExpertsName: '',//专家名称
      Stage: ['', ''],//开始、结束时间 
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数    
      options: [{
        id: 0,
        name: '加入团队后,仅查看'
      }],
      value: 0,
      shareIshow: false,
    }
  },
  created () {
    this.getProjectsList()
  },
  watch: {
    $route: {
      handler: function (to, from) {
        if (to.query.projectId != '' && to.query.projectId != undefined && to.query.projectId != null) {
          this.getSharingList(to.query.projectId, to.query.teamId, to.query.userId)
        }
      },
      // 深度观察监听 
      deep: true,
      immediate: true
    }
  },
  methods: {
    //分享进入页面列表
    async getSharingList (project_id, team_id, invite_id) {
      const { data: data } = await this.$http.post('project/join', {
        project_id,
        team_id,
        invite_id
      })
      this.getProjectsList()
      this.$message({
        message: data.message,
        type: 'success'
      });
      this.$router.push({ query: {} })
    },
    //获取项目列表
    async getProjectsList () {
      if (this.Stage == null) this.Stage = ['', '']
      const { data: data } = await this.$http.post('project/list', {
        project_name: this.ProjectsName,//?项目名称
        expert_name: this.ExpertsName,//?牵头专家名称
        start_time: this.Stage[0],//?创建开始时间 
        end_time: this.Stage[1],//?创建结束时间
        limit: this.pagesize,//?一页几条数据
        page: this.currentPage,//?第几页  
      })
      this.ProjectsObj = data.data
      this.$Spin.hide();
      if (this.ProjectsObj.list.length == 0) {
        this.tableText = "暂无数据";
      }
    },
    //搜索   
    search () {
      this.currentPage = 1
      setTimeout(() => {
        this.getProjectsList()
      }, 500)
      this.$Spin.show();
    },
    //项目回车 暂时不需要
    changeX (value) {
      return
      this.$Spin.show();
      this.ProjectsName = value
      this.currentPage = 1
      this.getProjectsList()
    },
    //专家回车 暂时不需要
    changeZ (value) {
      return
      this.$Spin.show();
      this.ExpertsName = value
      this.currentPage = 1
      this.getProjectsList()
    },
    // 添加项目 
    addHandle () {
      this.$router.push({
        path: '/editorProject',
        query: {
          id: ''
        }
      })
    },
    //点击详情进入  
    handleEdit (value) {
      this.$router.push({
        path: '/editorProject',
        query: {
          id: value.id
        }
      })
    },
    // 删除项目
    handleDelete (value) {
      //this.dialogVisible = true
      this.$confirm('您是否要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteApi(value.id)
      }).catch(() => { });
    },
    //删除项目 api
    async deleteApi (id) {
      const { data: data } = await this.$http.post('project/del', { id })
      this.$message({
        type: 'success',
        message: '删除成功!'
      });
      this.getProjectsList()
    },
    //分享
    async shareClick (row) {
      const { data: data } = await this.$http.post('project/share', { project_id: row.id })
      this.shareTime()
      this.getReproduction(data.data)
    },
    //复制样式
    shareTime () {
      window.clearTimeout(time)
      this.shareIshow = true
      let time = setTimeout(() => {
        this.shareIshow = false
        window.clearTimeout(time)
      }, 2000);
    },
    //分享复制
    getReproduction (data) {
      const getText = `${data.short_url}\n分享人:${data.share_user}\n项目:${data.project_name}`;
      let input = document.createElement("textarea");// js创建一个input(textarea)输入框   
      input.value = getText
      document.body.appendChild(input);//将输入框暂时创建到实例里面
      input.select();   // 选中输入框中的内容
      document.execCommand("Copy");    //执行复制操作
      document.body.removeChild(input) //最后删除实例中临时创建的input输入框，完成复制操作
    },
    //进入项目主页  
    examine (value) {
      this.$router.push({
        path: '/viewProject',
        query: {
          id: value.id
        }
      })
    },
    //查看项目
    ProjectHome (value) {
      this.$router.push({
        path: '/homeProject',
        query: {
          id: value.id,
          title: value.name
        }
      })
    },
    //取消删除
    cansol () {
      this.dialogVisible = false
    },
    //点击每一页 
    currentchange (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getProjectsList()
      }, 500)
      this.$Spin.show();
    },
    //上一页
    prevClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getProjectsList()
      }, 500)
      this.$Spin.show();
    },
    //下一页
    nextClick (e) {
      this.currentPage = e
      setTimeout(() => {
        this.getProjectsList()
      }, 500)
      this.$Spin.show();
    },
  }
}
</script>

<style lang='less'>
.share-box {
  position: relative;
  padding: 11px;
  padding-top: 3px;

  h4 {
    margin-bottom: 20px;
  }

  .share-box-item {
    display: flex;
    align-items: center;
  }
  .share-box-btn {
    position: relative;
    top: 0;
    right: 4px;
    width: 90px;
    height: 40px;
    background-color: #258ce8;
    color: #fff;
    font-size: 13px;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    transition: 0.5s;
  }
  .share-active {
    background-color: #36cfc9;
  }
}
</style>

<style lang='less' scoped>
.projectManagement {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    h4 {
      font-size: 28px;
      color: #212529;
    }
  }
  .el-card {
    flex: 1;
    .searchBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .inputBox {
        flex: 1;
        .el-input {
          width: 20%;
          margin-right: 24px;
        }
        .setDateTitle {
          margin-right: 14px;
          color: #8588ae;
          font-size: 18px;
        }
      }
      // 表格区域的样式
    }
    .table_box {
      margin-top: 40px;
    }
    .iconstyle {
      font-size: 20px;
      display: inline-block;
      width: 36px;
      height: 36px;
      border: 1px solid #f1f1f1;
      text-align: center;
      line-height: 36px;
      &:hover {
        cursor: pointer;
      }
      &:nth-child(1) {
        border-right: 0px;
      }
      &:nth-child(2) {
        border-right: 0px;
      }
      &:nth-child(3) {
        border-right: 0px;
      }
      img {
        width: 12px;
        height: 15px;
      }
    }

    .icon-size {
      font-size: 16px !important;
    }
    .lookat {
      color: #121fcf;
    }
    .edtor {
      color: #41ab1b;
    }
    .delete {
      color: #f12937;
    }
  }
  .page {
    text-align: right;
    margin-top: 24px;
  }
  .popup {
    width: 100%;
    text-align: center;
    margin-top: 30px;
    background: url("../../assets/image/cloud.png") no-repeat 0 0 / contain;
    font-size: 18px;
    color: #212529;
    .buttons {
      width: 80%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      margin-top: 87px;
      .el-button:nth-child(1) {
        background: #6c757d;
        color: #fff;
      }
      .el-button:nth-child(2) {
        background: #258ce8;
        color: #fff;
      }
    }
  }
  .el-table {
    margin-bottom: 20px;
    &::before {
      height: 0;
    }
    /deep/ tbody {
      tr {
        .el-table__cell {
          border: 0 none;
        }
      }
    }
  }

  /deep/.el-date-editor .el-range-separator {
    padding: 0;
  }

  /deep/ .el-card {
    overflow: visible;
  }

  // /deep/ .cell {
  //   display: flex;
  // }

  // .after {
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   padding: 5px;
  //   background-color: pink;
  //   transition: 0.3s;
  //   display: none;
  // }
  // /deep/ .el-tooltip__popper {
  //   max-width: 300px !important;
  // }

  /deep/ .el-table__row {
    cursor: pointer;
  }
}
</style> 
